require('./plugin.min.js');